import {Environment, getEnvironment} from '@/services/infrastructure/envhelper.service'
import {TogglableFeature} from '@/feature-toggles/feature-toggler.service'

export const ShowPatronDebugInfo: TogglableFeature = {
    isEnabled: () => {
        return getEnvironment() === Environment.Local || getEnvironment() === Environment.Staging
    }
}

export const DebugFeature: TogglableFeature = {
    isEnabled: () => {
        return getEnvironment() === Environment.Local || getEnvironment() === Environment.Staging
    }
}